import React from 'react'
import './AppMenu.css'
import { Navbar } from './react-bootstrap'

function AppMenu(props) {
  if (window.top !== window.self) return null

  return (
    <Navbar>
      <Navbar.Header>
        <Navbar.Brand>Geografia del Lavoro:</Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>
      <Navbar.Collapse>
        {renderItem('prof', 'Professioni')}
        {renderItem('sett', 'Settori')}
        {renderItem('terr', 'Territorio')}
      </Navbar.Collapse>
    </Navbar>
  )

  function renderItem(code, label) {
    return (
      <Navbar.Text className={code}>
        <Navbar.Link href={'?' + code} className={props.current === code ? 'current' : null}>
          {label}
        </Navbar.Link>
      </Navbar.Text>
    )
  }
}

export default AppMenu



// WEBPACK FOOTER //
// ./src/AppMenu.js